import { SET_CLIENT_SELECT, SET_COMPANY_SELECT, SET_BRANCH_SELECT, SET_USER_DATA, SET_USER_TYPE, SET_USER_ROLE } from "./actionType";
const savedClient = localStorage.getItem("clientSelected");
const savedCompany = localStorage.getItem("companySelected");
const savedBranch = localStorage.getItem("branchSelected");
const obj = JSON.parse(localStorage.getItem("authUser"));
const userData = obj?.data;
const userType = obj?.data?.userType;
const userRole = obj?.data?.user?.user_position?.position_role?.method;

const INIT_STATE = {
  clientSelected: savedClient ? JSON.parse(savedClient) : "",
  companySelected: savedCompany ? JSON.parse(savedCompany) : "",
  branchSelected: savedBranch ? JSON.parse(savedBranch) : "",
  userData: userData ? userData : null,
  userType: userType ? userType : "user",
  userRole: userRole ? userRole : null,
};

const App = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CLIENT_SELECT:
      return {
        ...state,
        clientSelected: action.payload,
      };
    case SET_COMPANY_SELECT:
      return {
        ...state,
        companySelected: action.payload,
      };
    case SET_BRANCH_SELECT:
      return {
        ...state,
        branchSelected: action.payload,
      };
    case SET_USER_DATA:
      return {
        ...state,
        userData: action.payload,
      };
    case SET_USER_TYPE:
      return {
        ...state,
        userType: action.payload,
      };
    case SET_USER_ROLE:
      return {
        ...state,
        userRole: action.payload,
      };
    default:
      return state;
  }
};

export default App;
